import { DragAndDropView, inputAndDiscussPinPhases } from '../../playerStore.types';
import { PlayerPinReducer, PlayerPinReducerFactory } from '../reducers.types';
import { nextPhase } from '../reducers.utils';

export type DragAndDropReducer = PlayerPinReducer<DragAndDropView>;

export const createDragAndDropReducer: PlayerPinReducerFactory<DragAndDropView> = () => dragAndDropReducer;

const dragAndDropReducer: DragAndDropReducer = {
  phases: inputAndDiscussPinPhases,
  initial: () => {
    return {
      type: 'DRAG_AND_DROP',
      phase: 'input',
    };
  },
  hasNextView: (state, currentView, direction) => {
    return nextPhase(currentView.phase, dragAndDropReducer.phases, direction) !== null;
  },
  handleNextView: (state, prev, direction) => {
    if (!prev) {
      return false;
    }

    const next = nextPhase(prev.phase, dragAndDropReducer.phases, direction);
    if (next) {
      return {
        type: 'DRAG_AND_DROP',
        phase: next,
      };
    }
    return false;
  },
  onNextView: async (state, prev, __, services, setBackgroundActionAction) => {
    if (prev.phase === 'input') {
      const action = () => services.apiService.dragAndDrop.checkPinStudentAnswers(state.currentPinId);
      setBackgroundActionAction?.(action);
      return action();
    }
    return null;
  },
  onEntriesUpdate: (_, currentView) => {
    return {
      ...currentView,
    };
  },
};
